var render = function () {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setting-page-content-wrapper chat-theme-settings" },
    [
      _c("div", { staticClass: "page-header" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("message.chatThemeSettings"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "subtitle" }, [
          _vm._v(_vm._s(_vm.$t("settings.chatThemeSettingsSubtitles"))),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "section",
        [
          _vm.isV2Theme
            ? _c("FeatureItem", {
                attrs: {
                  title: _vm.$t("settings.visitorNew"),
                  icon: "",
                  description:
                    "You can use the new version of the visitor theme.",
                },
                model: {
                  value: _vm.isVersionV2,
                  callback: function ($$v) {
                    _vm.isVersionV2 = $$v
                  },
                  expression: "isVersionV2",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isVersionV2
            ? _c("ChatThemeEditor", {
                attrs: { "update-settings": _vm.updateSettings },
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.isVersionV2
            ? _c(
                "div",
                [
                  _c("FeatureItem", {
                    staticStyle: { "margin-bottom": "10px" },
                    attrs: {
                      title: _vm.$t("message.theme"),
                      icon: "ThemeIcon",
                      type: "select",
                      options: [{ id: "custom", label: "Custom Theme" }].concat(
                        _vm.allThemeColors
                          .map(function (x) {
                            return { id: x, label: x }
                          })
                          .filter(function (x) {
                            return x.id !== "custom"
                          })
                      ),
                      "default-select-option-placeholder": _vm.$t(
                        "message.selectATheme"
                      ),
                      description: _vm.$t("settings.themeDescription"),
                      "show-null-select-option": false,
                    },
                    model: {
                      value: _vm.preferredThemeColor,
                      callback: function ($$v) {
                        _vm.preferredThemeColor = $$v
                      },
                      expression: "preferredThemeColor",
                    },
                  }),
                  _vm._v(" "),
                  _vm.preferredThemeColor === "custom"
                    ? _c(
                        "a-card",
                        { staticClass: "card" },
                        [
                          _c(
                            "a-card-grid",
                            {
                              staticStyle: {
                                width: "25%",
                                "text-align": "center",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "tippy",
                                      rawName: "v-tippy",
                                      value: {
                                        followCursor: true,
                                        placement: "bottom-end",
                                      },
                                      expression:
                                        "{\n                            followCursor: true,\n                            placement: 'bottom-end',\n                        }",
                                    },
                                  ],
                                  staticClass: "custom-field-slider",
                                  attrs: {
                                    content: _vm.$t("theme.headerColor1A"),
                                  },
                                },
                                [
                                  _c(
                                    "label",
                                    { attrs: { for: "themecolor1" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("theme.headerColor1"))
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("a-input", {
                                    staticClass: "theme-color-input",
                                    attrs: { id: "themecolor1", type: "color" },
                                    model: {
                                      value: _vm.themeColor1,
                                      callback: function ($$v) {
                                        _vm.themeColor1 = $$v
                                      },
                                      expression: "themeColor1",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("a-slider", {
                                    attrs: {
                                      max: 100,
                                      min: 0,
                                      step: 5,
                                      value: _vm.themeColor1A,
                                    },
                                    on: {
                                      change: function (value) {
                                        return (this$1.themeColor1A = value)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a-card-grid",
                            {
                              staticStyle: {
                                width: "25%",
                                "text-align": "center",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "tippy",
                                      rawName: "v-tippy",
                                      value: {
                                        followCursor: true,
                                        placement: "bottom-end",
                                      },
                                      expression:
                                        "{\n                            followCursor: true,\n                            placement: 'bottom-end',\n                        }",
                                    },
                                  ],
                                  staticClass: "custom-field-slider",
                                  attrs: {
                                    content: _vm.$t("theme.headerColor2A"),
                                  },
                                },
                                [
                                  _c(
                                    "label",
                                    { attrs: { for: "themecolor2" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("theme.headerColor2"))
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("a-input", {
                                    staticClass: "theme-color-input",
                                    attrs: { id: "themecolor2", type: "color" },
                                    model: {
                                      value: _vm.themeColor2,
                                      callback: function ($$v) {
                                        _vm.themeColor2 = $$v
                                      },
                                      expression: "themeColor2",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("a-slider", {
                                    attrs: {
                                      max: 100,
                                      min: 0,
                                      step: 5,
                                      value: _vm.themeColor2A,
                                    },
                                    on: {
                                      change: function (value) {
                                        return (this$1.themeColor2A = value)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a-card-grid",
                            {
                              staticStyle: {
                                width: "25%",
                                "text-align": "center",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "tippy",
                                      rawName: "v-tippy",
                                      value: {
                                        followCursor: true,
                                        placement: "bottom-end",
                                      },
                                      expression:
                                        "{\n                            followCursor: true,\n                            placement: 'bottom-end',\n                        }",
                                    },
                                  ],
                                  staticClass: "custom-field-slider",
                                  attrs: {
                                    content: _vm.$t("theme.backgroundColorA"),
                                  },
                                },
                                [
                                  _c(
                                    "label",
                                    { attrs: { for: "themecolor3" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("theme.backgroundColor"))
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("a-input", {
                                    staticClass: "theme-color-input",
                                    attrs: { id: "themecolor3", type: "color" },
                                    model: {
                                      value: _vm.themeColor3,
                                      callback: function ($$v) {
                                        _vm.themeColor3 = $$v
                                      },
                                      expression: "themeColor3",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("a-slider", {
                                    attrs: {
                                      max: 100,
                                      min: 0,
                                      step: 5,
                                      value: _vm.themeColor3A,
                                    },
                                    on: {
                                      change: function (value) {
                                        return (this$1.themeColor3A = value)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a-card-grid",
                            {
                              staticStyle: {
                                width: "25%",
                                "text-align": "center",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "tippy",
                                      rawName: "v-tippy",
                                      value: {
                                        followCursor: true,
                                        placement: "bottom-end",
                                      },
                                      expression:
                                        "{\n                            followCursor: true,\n                            placement: 'bottom-end',\n                        }",
                                    },
                                  ],
                                  staticClass: "custom-field-slider",
                                  attrs: {
                                    content: _vm.$t("theme.backgroundColor2A"),
                                  },
                                },
                                [
                                  _c(
                                    "label",
                                    { attrs: { for: "themecolor6" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("theme.backgroundColor2"))
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("label", [
                                    _vm._v(_vm._s(_vm.$t("theme.opacity"))),
                                  ]),
                                  _vm._v(" "),
                                  _c("a-input", {
                                    staticClass: "theme-color-input",
                                    attrs: { id: "themecolor6", type: "color" },
                                    model: {
                                      value: _vm.themeColor6,
                                      callback: function ($$v) {
                                        _vm.themeColor6 = $$v
                                      },
                                      expression: "themeColor6",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("a-slider", {
                                    attrs: {
                                      max: 100,
                                      min: 0,
                                      step: 5,
                                      value: _vm.themeColor6A,
                                    },
                                    on: {
                                      change: function (value) {
                                        return (this$1.themeColor6A = value)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.preferredThemeColor === "custom"
                    ? _c(
                        "a-card",
                        { staticClass: "card" },
                        [
                          _c(
                            "a-card-grid",
                            {
                              staticStyle: {
                                width: "25%",
                                "text-align": "center",
                              },
                            },
                            [
                              _c(
                                "div",
                                [
                                  _c(
                                    "label",
                                    { attrs: { for: "themecolor5" } },
                                    [_vm._v(_vm._s(_vm.$t("theme.errorTheme")))]
                                  ),
                                  _vm._v(" "),
                                  _c("a-input", {
                                    staticClass: "width-80",
                                    attrs: { id: "themecolor5", type: "color" },
                                    model: {
                                      value: _vm.themeColor5,
                                      callback: function ($$v) {
                                        _vm.themeColor5 = $$v
                                      },
                                      expression: "themeColor5",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a-card-grid",
                            {
                              staticStyle: {
                                width: "25%",
                                "text-align": "center",
                              },
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "font-size-13",
                                  attrs: { for: "chatBubbleBackground", v: "" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("theme.bubbleBackground"))
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("a-input", {
                                staticClass: "width-80",
                                attrs: {
                                  id: "chatBubbleBackground",
                                  type: "color",
                                },
                                model: {
                                  value: _vm.chatBubbleBackground,
                                  callback: function ($$v) {
                                    _vm.chatBubbleBackground = $$v
                                  },
                                  expression: "chatBubbleBackground",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "a-card-grid",
                            {
                              staticStyle: {
                                width: "25%",
                                "text-align": "center",
                              },
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "font-size-13",
                                  attrs: {
                                    for: "chatBubbleVisitorBackground",
                                    v: "",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("theme.bubbleVisitorBackground")
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("a-input", {
                                staticClass: "width-80",
                                attrs: {
                                  id: "chatBubbleVisitorBackground",
                                  type: "color",
                                },
                                model: {
                                  value: _vm.chatBubbleVisitorBackground,
                                  callback: function ($$v) {
                                    _vm.chatBubbleVisitorBackground = $$v
                                  },
                                  expression: "chatBubbleVisitorBackground",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "a-card-grid",
                            {
                              staticStyle: {
                                width: "25%",
                                "text-align": "center",
                              },
                            },
                            [
                              _c(
                                "label",
                                { attrs: { for: "chatBubbleText" } },
                                [_vm._v(_vm._s(_vm.$t("theme.bubbleText")))]
                              ),
                              _vm._v(" "),
                              _c("a-input", {
                                staticClass: "width-80",
                                attrs: { id: "chatBubbleText", type: "color" },
                                model: {
                                  value: _vm.chatBubbleText,
                                  callback: function ($$v) {
                                    _vm.chatBubbleText = $$v
                                  },
                                  expression: "chatBubbleText",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "a-card-grid",
                            {
                              staticStyle: {
                                width: "25%",
                                "text-align": "center",
                              },
                            },
                            [
                              _c(
                                "label",
                                { attrs: { for: "chatBubbleVisitorText" } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("theme.bubbleVisitorText"))
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("a-input", {
                                staticClass: "width-80",
                                attrs: {
                                  id: "chatBubbleVisitorText",
                                  type: "color",
                                },
                                model: {
                                  value: _vm.chatBubbleVisitorText,
                                  callback: function ($$v) {
                                    _vm.chatBubbleVisitorText = $$v
                                  },
                                  expression: "chatBubbleVisitorText",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "a-card-grid",
                            {
                              staticStyle: {
                                width: "25%",
                                "text-align": "center",
                              },
                            },
                            [
                              _c("label", { attrs: { for: "themeColor4" } }, [
                                _vm._v(_vm._s(_vm.$t("theme.textColor"))),
                              ]),
                              _vm._v(" "),
                              _c("a-input", {
                                staticClass: "width-80",
                                attrs: { id: "themeColor4", type: "color" },
                                model: {
                                  value: _vm.themeColor4,
                                  callback: function ($$v) {
                                    _vm.themeColor4 = $$v
                                  },
                                  expression: "themeColor4",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "a-card-grid",
                            {
                              staticStyle: {
                                width: "25%",
                                "text-align": "center",
                              },
                            },
                            [
                              _c("label", { attrs: { for: "themeColor7" } }, [
                                _vm._v(_vm._s(_vm.$t("theme.textFormColor"))),
                              ]),
                              _vm._v(" "),
                              _c("a-input", {
                                staticClass: "width-80",
                                attrs: { id: "themeColor7", type: "color" },
                                model: {
                                  value: _vm.themeColor7,
                                  callback: function ($$v) {
                                    _vm.themeColor7 = $$v
                                  },
                                  expression: "themeColor7",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "a-card-grid",
                            {
                              staticStyle: {
                                width: "25%",
                                "text-align": "center",
                              },
                            },
                            [
                              _c(
                                "a-button",
                                {
                                  staticClass: "previewButton btnColor",
                                  attrs: { danger: "", ghost: "" },
                                  on: { click: _vm.previewApp },
                                },
                                [
                                  _vm.previewLoading
                                    ? _c("font-awesome-icon", {
                                        attrs: { icon: "spinner", spin: "" },
                                      })
                                    : _c("span", [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.isPreviewActive
                                                ? _vm.$t(
                                                    "message.closePreviewColors"
                                                  )
                                                : _vm.$t(
                                                    "message.previewColors"
                                                  )
                                            ) +
                                            "\n                        "
                                        ),
                                      ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }